import type { ComponentProps } from 'react';
import { Text } from '@fiverr-private/typography';

export const textCommonProps: ComponentProps<typeof Text> = {
    color: 'white',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
};
